import { render } from "./counsellor.vue?vue&type=template&id=43258c5a&scoped=true"
import script from "./counsellor.vue?vue&type=script&lang=js"
export * from "./counsellor.vue?vue&type=script&lang=js"

import "./counsellor.vue?vue&type=style&index=0&id=43258c5a&lang=less&scoped=true"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43258c5a"]])

export default __exports__